/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LpFineDrivingBanMeta from "./LpFineDrivingBanMeta";
import Layout from "../../../../Layouts/Layout";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import IncorrectPenaltySection from "../../../../../components/Sections/Traffic/IncorrectPenaltySection/IncorrectPenaltySection";
import TrafficCheckin from "../../../../../components/Checkin/TrafficCheckin/TrafficCheckin";
import Container from "../../../../../components/Container/Container";
import TrafficCostRiskSection from "../../../../../components/Sections/Traffic/TrafficCostRiskSection/TrafficCostRiskSection";
import { getLastPathSplit } from "../../../../../services/redirect";
import { landingPagesList } from "../../../../../services/landingPagesList";
import PartnersSection from "../../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { trafficTeaserCards } from "../../../../../services/landingPageService";
import { useLocation } from "react-router";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";
import HowItWorksSectionTraffic
  from "../../../../../components/Sections/Traffic/HowItWorksSection/HowItWorksSectioTraffic";

const LpFineDrivingBan = () => {
  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Bußgeldbescheid & Fahrverbot";
  const headline = (lpKey && landingPagesList[lpKey]?.headline) ?? "Jetzt Einspruch einlegen!";
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpFineDrivingBanMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Effektiv gegen Bußgeld, Punkte oder Fahrverbot vorgehen"}
        teaserButtonText={"Kostenlose Ersteinschätzung"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={trafficTeaserCards} />
      </LandingPageTeaser>
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <TrafficCheckin
              idPrefix={"top"}
              checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung! Was wird Ihnen vorgeworfen?"}
              accusation={{
                name: "accusation",
                detail: {
                  name: "accusation",
                  label: "Vorwurf auswählen",
                  options: [
                    { value: "speeding", label: "Geschwindigkeitsverstoß" },
                    { value: "red_light", label: "Rotlichtverstoß" },
                    { value: "distance", label: "Abstandsverstoß" },
                    { value: "other", label: "Handy / Drogen / Parken / Sonstiges" },
                  ],
                },
              }}
            />
          </Container>
        )}
        <IncorrectPenaltySection />
      </GreyBackgroundWrapper>
      <HowItWorksSectionTraffic />
      <TrafficCostRiskSection />
      <GreyBackgroundWrapper>
        <AttorneySection
          product={"traffic"}
          textCards={false}
          subheading={"Sie möchten professionell und unkompliziert gegen Ihren Bescheid vorgehen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        />
        <AdvantagesLegalbirdAttorneySection product={"traffic"} />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <TrafficCheckin
            idPrefix={"bottom"}
            checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung! Was wird Ihnen vorgeworfen?"}
            accusation={{
              name: "accusation",
              detail: {
                name: "accusation",
                label: "Vorwurf auswählen",
                options: [
                  { value: "speeding", label: "Geschwindigkeitsverstoß" },
                  { value: "red_light", label: "Rotlichtverstoß" },
                  { value: "distance", label: "Abstandsverstoß" },
                  { value: "other", label: "Handy / Drogen / Parken / Sonstiges" },
                ],
              },
            }}
          />
        </Container>
      )}
      <PartnersSection />
    </Layout>
  );
};

export default LpFineDrivingBan;
